module.exports = __webpack_public_path__ + "img/IAM.318a0036.png";